import { createContext, Dispatch, FC, PropsWithChildren, useContext, useReducer } from 'react'
import { noop } from 'antd-mobile/es/utils/noop'

const initialState = {
  user: {}, // isLogin bindPhoneFlag
  role: {},
  centerConfig: {}, // 客服中心配置
  pageLoading: false, // 页面初始化状态
  isInnerOpen: false, // 是否是内部打开
  inner: {
    type: null,
    kfId: null,
    isFrom: false
  },
  isFirst: true, // 是否是第一次进入
  isPhoneStrate: false, // 没有bindPhoneFlag且phoneStrategy为2的情况
  hwLoginModalOpen: false // 海外登录弹框状态
};

// const combineReducers = reducers => {
//
// }

export const actionTypes = {
  SET_USER: 'SET_USER',
  SET_ROLE: 'SET_ROLE',
  SET_CENTER_CONFIG: 'SET_CENTER_CONFIG',
  LOGOUT: 'LOGOUT',
  SET_PAGE_LOADING: 'SET_PAGE_LOADING',
  SET_INNER: 'SET_INNER',
  SET_PHONE_STRATE: 'SET_PHONE_STRATE',
  SET_FIRST_STRATE: 'SET_FIRST_STRATE',
  SET_HW_LOGIN_MODAL: 'SET_HW_LOGIN_MODAL', // 海外登录弹框
}

const reducer = (state, action) => {
  switch (action.type) {
    case actionTypes.SET_USER:
      return { ...state, user: action.payload };
    case actionTypes.SET_ROLE:
      return { ...state, role: action.payload };
    case actionTypes.SET_CENTER_CONFIG:
      return { ...state, centerConfig: action.payload };
    case actionTypes.LOGOUT:
      return { ...state, user: {}, role: {} };
    case actionTypes.SET_PAGE_LOADING:
      return { ...state, pageLoading: action.payload };
    case actionTypes.SET_INNER:
      return { ...state, inner: action.payload };
    case actionTypes.SET_PHONE_STRATE:
      return { ...state, isPhoneStrate: action.payload };
    case actionTypes.SET_FIRST_STRATE:
      return { ...state, isFirst: action.payload };
    case actionTypes.SET_HW_LOGIN_MODAL:
      return { ...state, hwLoginModalOpen: action.payload };
    default:
      return state;
  }
}



const StateContext = createContext(initialState);
const DispatchContext = createContext<Dispatch<any>>(noop);

export const useStoreState = () => useContext(StateContext);
export const useStoreDispatch = () => useContext(DispatchContext);

export const StoreProvider: FC<PropsWithChildren> = props => {
  const [state, dispatch] = useReducer(reducer, initialState);
  return <DispatchContext.Provider value={dispatch}>
    <StateContext.Provider value={state}>{props.children}</StateContext.Provider>
  </DispatchContext.Provider>
}



